import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ReactTyped } from "react-typed";
import video1 from '../assets/img/video1.mp4'
import axios from 'axios';

export const Header = ({ videoLoaded, type }) => {

  const [suggestions, setSuggestions] = useState([]);
  const [book, setBook] = useState({});
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [search, setSearch] = useState('');
  const delay = ms => new Promise(res => setTimeout(res, ms));
  const navigate = useNavigate();
  const typingTimeout = useRef(null);

  async function getSuggestions(query) {
    if (suggestions !== 'undefined' || !showSuggestions) {
      setSuggestions(undefined)
      setShowSuggestions(true)
    }
    if (typingTimeout.current) {
      clearTimeout(typingTimeout.current);
    }

    typingTimeout.current = setTimeout(async () => {
      axios({
        method: 'post',
        url: '/api/getSuggestions',
        data: {
            'query': query
        }
      })
      .then(response => {
        setSuggestions(response.data);
        if (typeof response.data !== 'undefined') {
          setShowSuggestions(true)
        } else {
          setShowSuggestions(false)
        }
      })
      .catch(error => {
        console.log(error);
      });
    }, 1000)
  }

  function findBook(id, title) {
    let searchBar = document.getElementById("default-search")
    searchBar.value = title
    axios({
      method: 'post',
      url: '/api/findApiBook',
      data: {
          'bookId': id
      }
    })
    .then(response => {
      setBook(response.data);
      setShowSuggestions(false)
      navigate(`/bøger?id=${response.data['bookId']}`)
    })
    .catch(error => {
      console.log(error);
    });
  }

  useEffect(() => {
    if (search.length > 2) {
      getSuggestions(search)
    } else {
      setShowSuggestions(false)
    }
  }, [search])

  return (
    <div className="h-lvh sm:min-h-[600px] flex mx-auto hero">
      <div className="w-full hero-bg content bg-blue-500 relative flex">
        <div className="absolute w-full h-full bg-gradient-to-r from-indigo-500 to-emerald-500 overflow-hidden">
          <video autoPlay muted loop playsInline className="opacity-60 min-h-full object-cover w-full" onLoadedData={() => videoLoaded(true)}>
            <source src={video1} />
          </video>
        </div>
        <div className="h-auto innerContainer mx-auto py-20 flex flex-col justify-center">
          <div className="relative flex flex-col gap-10">
            <h1 className="sr-only">
              Køb og sælg brugte bøger online – nemt og billigt
            </h1>
            <h2 className="font-bold 2xl:text-5xl lg:text-4xl md:text-3xl text-3xl text-white drop-shadow-xl opacity-0 select-none">
              Køb og sælge brugte<br /> bøger
            </h2>
            <h2 className="text-center md:text-left w-full absolute top-0 font-bold 2xl:text-5xl lg:text-4xl md:text-3xl text-3xl text-white drop-shadow-xl select-none md:w-3/5">
              {(type ? <ReactTyped strings={["Køb dine bøger billigere end nogensinde før", "Få din bog sendt med posten eller afhent selv", "Sikker handel med garanteret levering af din bog"]} typeSpeed={25} backSpeed={20} backDelay={4000} loop /> : "")}
            </h2>
            <div className="flex flex-col gap-2">
              <p className="text-sm md:text-base text-white font-medium select-none">Søg efter bog</p>
              <div className="flex select-none">
                <div className="relative w-full md:w-3/5 lg:w-2/5">
                  <input className="text-xs md:text-sm w-full outline-none px-5 sm:px-10 py-4 truncate" id="default-search" autoComplete='off' placeholder="Indtast titel, forfatter eller ISBN ..." onChange={(e) => (setSearch(e.target.value))} />
                  <div className={"absolute bg-white w-full max-h-56 overflow-y-auto shadow-lg bg-gray-50 bt-none " + (showSuggestions ? "opacity-100 pointer-events-auto" : "p-0 opacity-0 pointer-events-none")}>
                    {
                      (typeof suggestions === 'undefined') ? (
                        <div className="p-4 ps-10 text-sm">Søger...</div>
                      ) : (
                        suggestions.map((data, index) => {
                          return <li onClick={() => navigate(`/bøger?title=${data['title'].toLowerCase()}`)} key={index} className={"list-none p-4 ps-10 text-sm cursor-pointer hover:bg-gray-200 " + (showSuggestions ? "block" : "hidden")}>
                            <h2>{data['title']}</h2>
                            <p className="text-xs">{data['version']}</p>
                          </li>
                        })
                      )
                    }
                  </div>
                </div>
                <Link className='flex' to="/bøger"><div className="text-sm lg:text-base bg-size-200 bg-pos-0 hover:bg-pos-100 transition-all duration-150 ease-in-out text-white bg-gradient-to-r from-emerald-500 to-emerald-800 py-2 px-8 font-medium mr-auto cursor-pointer shadow-lg flex items-center">Søg</div></Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}